import React from "react";

export default function NoneFound({ text = "None found" }) {
  return (
    <div className="space-y-3 mt-2 bg-white border border-slate-100 rounded py-5 px-6">
      <p className="py-1 flex justify-center text-gray-300">{text}</p>
    </div>
  );
}
